import { render } from "./VenueDetail.vue?vue&type=template&id=2a620934&scoped=true"
import script from "./VenueDetail.vue?vue&type=script&lang=js"
export * from "./VenueDetail.vue?vue&type=script&lang=js"

import "./VenueDetail.vue?vue&type=style&index=0&id=2a620934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a620934"]])

export default __exports__